export default __webpack_public_path__ + "static/media/logo_solutis.8986a7fb.svg";